// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__xhmrM","header":"style_header__kaEhY"};